import React, { useEffect,useState } from "react";

import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import PropTypes from "prop-types";
const AuthWrapper = ({ children }) => {
    const { instance, inProgress, accounts } = useMsal();
    // const navigate = useNavigate();
    const [isAuthenticated, setIsAuthenticated] = useState(false);
  
    useEffect(() => {
      if (accounts.length > 0) {
        setIsAuthenticated(true);
      } else if (inProgress === InteractionStatus.None) {
        instance.loginRedirect().catch(error => console.error("Login failed", error));
      }
    }, [instance, inProgress, accounts]);
  
    
    if (!isAuthenticated) {
      return <div>Loading authentication...</div>; // Show a loading screen until login is complete
    }
  
    return <>{children}</>;
  };
  
AuthWrapper.propTypes = {
    children: PropTypes.node.isRequired,
  };

export default AuthWrapper;